// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1u3yq","title":"AfterBackImages_title__txsbx","images":"AfterBackImages_images__1o3mY"};